import React, { useEffect, useState } from "react";
import "./agentstable.css";
import {
  Table,
  Dropdown,
  Menu,
  message,
  Modal as AntModal,
  Switch,
  Spin,
} from "antd";
import { useNavigate } from "react-router-dom";
import { BsThreeDots } from "react-icons/bs";
import { FaPlus } from "react-icons/fa6";
import AddAgentModal from "../../agents page/agent modal/AddAgentModal";
import ViewAgentModal from "../../agents page/view agent modal/ViewAgentModal";
import EditAgentModal from "../../agents page/edit modal/EditAgentModal";
import AgentDeleteModal from "../../agents page/deletemodal/AgentDeleteModal";

import { DatePicker, Radio } from "antd";
import dayjs from "dayjs";
import { Modal } from "react-bootstrap";
import Instance from "../../../AxiosConfig";

const AgentsTable = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const [loading, setLoading] = useState(false);
  const [showTargetModal, setShowTargetModal] = useState(false);

  const [targetAmount, setTargetAmount] = useState("");

  const [applicableFrom, setApplicableFrom] = useState("");

  const [targetId, setTargetId] = useState(null);

  const [targetLoading, setTargetLoading] = useState(false);

  const [targetHistory, setTargetHistory] = useState({});


  const [showExitModal, setShowExitModal] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);

  const [exitDateOption, setExitDateOption] = useState("today");
  const [customExitDate, setCustomExitDate] = useState(null);

  const [showJoiningModal, setShowJoiningModal] = useState(false);
  const [joiningDateOption, setJoiningDateOption] = useState("today");
  const [customJoiningDate, setCustomJoiningDate] = useState(dayjs());


  const saveExitDate = async () => {
    try {
      const exitDate =
        exitDateOption === "today"
          ? new Date().toISOString()
          : customExitDate?.toISOString();

      if (!exitDate) {
        return message.error("Please select an exit date");
      }

      await Instance.patch(
        `/agents/${selectedAgent._id}/employment-history/exit-date`,
        {
          exitDate,
        }
      );

      await Instance.patch(`/agents/${selectedAgent._id}/status`, {
        status: "INACTIVE",
      });

      message.success("Agent marked as inactive");

      setShowExitModal(false);
      setSelectedAgent(null);
      setExitDateOption("today");
      setCustomExitDate(null);

      fetchData();
    } catch (err) {
      console.error(err);

      message.error(
        err?.response?.data?.message || "Failed to update status"
      );
    }
  };

  const saveJoiningDate = async () => {
    try {
      const joiningDate =
        joiningDateOption === "today"
          ? new Date().toISOString()
          : customJoiningDate?.toISOString();

      if (!joiningDate) {
        return message.error("Please select a joining date");
      }

      await Instance.patch(
        `/agents/${selectedAgent._id}/employment-history/joining-date`,
        {
          joiningDate,
        }
      );

      await Instance.patch(`/agents/${selectedAgent._id}/status`, {
        status: "ACTIVE",
      });

      message.success("Agent marked as active");

      setShowJoiningModal(false);
      setSelectedAgent(null);
      setJoiningDateOption("today");
      setCustomJoiningDate(dayjs());

      fetchData();
    } catch (err) {
      console.error(err);

      message.error(
        err?.response?.data?.message || "Failed to update status"
      );
    }
  };

  const handleModalClick = async (key, record) => {
    setSelectedData(record);

    if (key === "edit") {
      setShowEditModal(true);
    } else if (key === "addTarget") {
      setTargetId(null);
      setTargetAmount("");
      setApplicableFrom("");
      setShowTargetModal(true);
    } else if (key === "editTarget") {
      await openTargetModal(record);
    }
  };

  console.log("selected data", selectedData);

  const menu = (record) => (
    <Menu onClick={({ key }) => handleModalClick(key, record)}>
      <Menu.Item key="edit">Edit Agent</Menu.Item>

      <Menu.Item key="addTarget">Add New Target</Menu.Item>
    </Menu>
  );
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await Instance.get("/agents");

      console.log("Agents API Response:", response);
      if (response.status === 200) {
        const agents = (response.data.agents || [])
          .filter((item) => item.role === "AGENT")
          .sort((a, b) => {
            if (a.status === b.status) return 0;

            if (a.status === "ACTIVE") return -1;

            return 1;
          });

        setData(agents);
      }
    } catch (error) {
      console.error("Error fetching agents:", error);
      message.error("Failed to fetch agents");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const updateStatus = async (record, checked) => {
    try {
      // ACTIVE
      if (checked) {
        setSelectedAgent(record);
        setJoiningDateOption("today");
        setCustomJoiningDate(dayjs());
        setShowJoiningModal(true);
        return;
      }

      // INACTIVE -> ask exit date
      setSelectedAgent(record);
      setExitDateOption("today");
      setCustomExitDate(dayjs());
      setShowExitModal(true);
    } catch (error) {
      message.error("Failed to update status");
    }
  };

  const fetchTargetHistory = async (agentId) => {
    try {
      const response = await Instance.get(`/agents/${agentId}/targets`);

      setTargetHistory((prev) => ({
        ...prev,
        [agentId]: response.data.targets || [],
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const openTargetModal = async (record) => {
    try {
      setSelectedData(record);
      setTargetLoading(true);

      const response = await Instance.get(`/agents/${record._id}/targets`);

      const currentTarget = response?.data?.currentTarget;

      if (!currentTarget) {
        message.warning("No current target found");
        return;
      }

      setTargetId(currentTarget._id);

      setTargetAmount(currentTarget.targetAmount || "");

      setApplicableFrom(
        currentTarget.applicableFrom
          ? currentTarget.applicableFrom.split("T")[0]
          : "",
      );

      setShowTargetModal(true);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch current target");
    } finally {
      setTargetLoading(false);
    }
  };
  const editTarget = (record, target) => {
    setSelectedData(record);

    setTargetId(target._id);

    setTargetAmount(target.targetAmount);

    setApplicableFrom(
      target.applicableFrom ? target.applicableFrom.split("T")[0] : "",
    );

    setShowTargetModal(true);
  };

  const deleteTarget = async (agentId, targetId) => {
    try {
      await Instance.delete(`/agents/${agentId}/targets/${targetId}`);

      message.success("Target deleted successfully");

      fetchTargetHistory(agentId);
      fetchData();
    } catch (error) {
      console.error(error);
      message.error("Failed to delete target");
    }
  };

  const saveTarget = async () => {
    if (!targetAmount || !applicableFrom) {
      return message.error("Target Amount and Applicable From are required");
    }

    try {
      setTargetLoading(true);

      let response;

      if (targetId) {
        response = await Instance.put(
          `/agents/${selectedData._id}/targets/${targetId}`,
          {
            targetAmount: Number(targetAmount),
            applicableFrom,
          },
        );

        message.success("Current target updated successfully");
      } else {
        response = await Instance.post(`/agents/${selectedData._id}/targets`, {
          targetAmount: Number(targetAmount),
          applicableFrom,
        });

        message.success("New target added successfully");
      }

      if (response.status === 200 || response.status === 201) {
        fetchData();

        setShowTargetModal(false);

        setTargetId(null);
        setTargetAmount("");
        setApplicableFrom("");
      }
    } catch (error) {
      console.error(error);
      message.error("Failed to save target");
    } finally {
      setTargetLoading(false);
    }
  };

  const columns = [
    {
      title: "Agent Name",
      dataIndex: "agentName",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Mobile Number",
      dataIndex: "number",
    },
    {
      title: "Assigned Manager",
      dataIndex: "managerName",
      render: (value) => value || "-",
    },
    {
      title: "Total Target",
      dataIndex: "totalTarget",
      render: (value) => `₹${value || 0}`,
    },
    {
      title: "Status",
      render: (_, record) => (
        <Switch
          checked={(record.status || "ACTIVE") === "ACTIVE"}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          onChange={(checked) => updateStatus(record, checked)}
        />
      ),
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Dropdown overlay={menu(record)} trigger={["click"]}>
          <BsThreeDots
            style={{
              fontSize: "20px",
              cursor: "pointer",
            }}
          />
        </Dropdown>
      ),
    },
  ];

  return (
    <div>
      {/* <CompanyDashboard /> */}
      <div className="agents-page mt-5">
        <div className="agents-table mt-3">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="agents-heading-h1">Agents List</h1>
            <div className="d-flex align-items-center gap-3 table-header-buttons">
              <button className="surve-export-btn" onClick={handleShow}>
                <FaPlus /> Add New Agent
              </button>
            </div>
          </div>
          <div className="mt-4">
            <Table
              columns={columns}
              dataSource={data}
              pagination={false}
              rowKey="_id"
              expandable={{
                onExpand: (expanded, record) => {
                  if (expanded) {
                    fetchTargetHistory(record._id);
                  }
                },

                expandedRowRender: (record) => (
                  <Table
                    pagination={false}
                    rowKey="_id"
                    dataSource={targetHistory[record._id] || []}
                    columns={[
                      {
                        title: "Target Amount",
                        dataIndex: "targetAmount",
                        render: (value) => `₹${value}`,
                      },
                      {
                        title: "Applicable From",
                        dataIndex: "applicableFrom",
                        render: (date) => date?.split("T")[0],
                      },
                      {
                        title: "Action",
                        render: (_, target) => (
                          <div className="d-flex gap-2">
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() => editTarget(record, target)}
                            >
                              Edit
                            </button>

                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => {
                                AntModal.confirm({
                                  title: "Delete Target",
                                  content:
                                    "Are you sure you want to delete this target?",
                                  okText: "Delete",
                                  okType: "danger",
                                  onOk: () =>
                                    deleteTarget(record._id, target._id),
                                });
                              }}
                            >
                              Delete
                            </button>
                          </div>
                        ),
                      },
                    ]}
                  />
                ),
              }}
            />
          </div>
        </div>
      </div>
      <AddAgentModal
        show={showModal}
        handleClose={handleClose}
        fetchData={fetchData}
      />
      <ViewAgentModal
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        agentData={selectedData}
      />
      <EditAgentModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        agentData={selectedData}
        fetchData={fetchData}
      />
      <AgentDeleteModal
        show={showDelete}
        onClose={() => setShowDelete(false)}
        agentData={selectedData}
        fetchData={fetchData}
      />
      <AntModal
        open={showTargetModal}
        footer={null}
        centered
        destroyOnClose
        onCancel={() => {
          setShowTargetModal(false);
          setTargetId(null);
        }}
        title={`${targetId ? "Edit Current Target" : "Add New Target"
          } - ${selectedData?.agentName || ""}`}
      >
        <div className="mb-3">
          <label className="form-label">Target Amount *</label>

          <input
            type="number"
            className="form-control"
            value={targetAmount}
            onChange={(e) => setTargetAmount(e.target.value)}
            placeholder="Enter target amount"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Applicable From *</label>

          <input
            type="date"
            className="form-control"
            value={applicableFrom}
            onChange={(e) => setApplicableFrom(e.target.value)}
          />
        </div>

        <div className="d-flex justify-content-end gap-2">
          <button
            className="users-discard-button"
            onClick={() => setShowTargetModal(false)}
          >
            Cancel
          </button>

          <button
            className="users-save-button"
            onClick={saveTarget}
            disabled={targetLoading}
          >
            {targetLoading ? (
              <>
                <Spin size="small" />
                &nbsp;Saving...
              </>
            ) : targetId ? (
              "Update Target"
            ) : (
              "Add Target"
            )}
          </button>
        </div>
      </AntModal>

      <AntModal
        open={showExitModal}
        title={`Mark ${selectedAgent?.agentName} as Inactive`}
        onCancel={() => {
          setShowExitModal(false);
          setSelectedAgent(null);
          setExitDateOption("today");
          setCustomExitDate(null);
        }}
        footer={null}
        destroyOnClose
      >
        <Radio.Group
          value={exitDateOption}
          onChange={(e) => setExitDateOption(e.target.value)}
          className="d-flex flex-column gap-3"
        >
          <Radio value="today">
            Use Current Date ({dayjs().format("DD-MM-YYYY")})
          </Radio>

          <Radio value="custom">
            Custom Date
          </Radio>
        </Radio.Group>

        {exitDateOption === "custom" && (
          <div className="mt-3">
            <DatePicker
              style={{ width: "100%" }}
              value={customExitDate}
              onChange={(date) => setCustomExitDate(date)}
            />
          </div>
        )}

        <div className="d-flex justify-content-end gap-2 mt-4">
          <button
            className="users-discard-button"
            onClick={() => {
              setShowExitModal(false);
              setSelectedAgent(null);
            }}
          >
            Cancel
          </button>

          <button
            className="users-save-button"
            onClick={saveExitDate}
          >
            Confirm
          </button>
        </div>
      </AntModal>

      <AntModal
        open={showJoiningModal}
        title={`Mark ${selectedAgent?.agentName} as Active`}
        onCancel={() => {
          setShowJoiningModal(false);
          setSelectedAgent(null);
          setJoiningDateOption("today");
          setCustomJoiningDate(dayjs());
        }}
        footer={null}
        destroyOnClose
      >
        <Radio.Group
          value={joiningDateOption}
          onChange={(e) => setJoiningDateOption(e.target.value)}
          className="d-flex flex-column gap-3"
        >
          <Radio value="today">
            Use Current Date ({dayjs().format("DD-MM-YYYY")})
          </Radio>

          <Radio value="custom">
            Custom Date
          </Radio>
        </Radio.Group>

        {joiningDateOption === "custom" && (
          <div className="mt-3">
            <DatePicker
              style={{ width: "100%" }}
              value={customJoiningDate}
              onChange={(date) => setCustomJoiningDate(date)}
            />
          </div>
        )}

        <div className="d-flex justify-content-end gap-2 mt-4">
          <button
            className="users-discard-button"
            onClick={() => {
              setShowJoiningModal(false);
              setSelectedAgent(null);
            }}
          >
            Cancel
          </button>

          <button
            className="users-save-button"
            onClick={saveJoiningDate}
          >
            Confirm
          </button>
        </div>
      </AntModal>

    </div>
  );
};

export default AgentsTable;
